import ace from "brace";
import LZString from "lz-string";
import * as widgets from "..";
import * as z from "../../../../../framework";
import { Widget } from "../widget";
import editView from "./customizableWidgetEdit.view";

// tslint:disable-next-line:no-var-requires
require("brace/mode/json");

const theme = "github";
// tslint:disable-next-line:no-var-requires
require(`brace/theme/${theme}`);

// tslint:disable-next-line:variable-name
export var W_Customizable = function (widgetInstance?) {
    let me = this;

    me.widgetInstance = widgetInstance || {};
    me.widgetInstance.Widget = me.widgetInstance.Widget || {};
    me.widgetInstance.Widget.WidgetType = me.widgetInstance.Widget.WidgetType || {};
    me.widgetInstance.height = 500;

    let screen = new Widget(widgetInstance);
    $.extend(this, screen);
    me.screen = screen;

    me.prepare();
    me.init();
};

W_Customizable.prototype = {
    init: function () {
        let me = this;
        me.addEditIcon();

        if (me.parseJson(me.widgetInstance.Widget.Options)) {
            me.renderCustomView();
        } else {
            me.renderEditView();
        }
    },
    prepare: function (newJsonOptions?: string) {
        let me = this;

        me.current = {};
        me.current.optionsJson = newJsonOptions === undefined
            ? me.widgetInstance.Widget.Options
            : newJsonOptions;
        me.current.options = me.parseJson(me.current.optionsJson) || {};

        // this needs to be deleted for the z.deepClone or it will create a circular reference and throw an exception
        delete me.widgetInstance.widgetElement;

        me.current.constructorObject = z.deepClone(me.widgetInstance);
        me.current.constructorObject.screen = me.screen;
        me.current.constructorObject.custom = true;
        me.current.constructorObject.screen.options = me.current.options;
        me.current.constructorObject.Widget.Options = me.current.optionsJson;
        me.current.constructorObject.Widget.WidgetType.Value = me.current.options.WidgetType && me.current.options.WidgetType.startsWith("W_")
            ? me.current.options.WidgetType
            : `W_${me.current.options.WidgetType}`;
    },
    addEditIcon: function () {
        let me = this,
            id = me.screen
                ? me.screen.id
                : me.id,
            containerSelector = `#${id}_WidgetContainer `;

        if ($(`${containerSelector}.edit-widget-icon`).length > 0) {
            return;
        }

        const editButtonHtml = "<span class='edit-widget-icon'></span>";
        $(`${containerSelector}.widget-icons`).prepend(editButtonHtml);

        $(`${containerSelector}.edit-widget-icon`).tie("click", function () {
            me.renderEditView();
        });
    },
    renderEditView: function (validationError) {
        let me = this,
            widgetContents = me.get("#WidgetContainer .z-widget-contents");

        me.deleteCurrentViewAndSetHeight(266);
        me.showPrintButton(false);

        let workspace = editView();
        workspace.options.zScreen = me;
        workspace.render(widgetContents);

        z.bindLocalizedLanguage({ container: me.get("#WidgetContainer") });

        let id = me.get("#EditJson").selector;
        if (id.length > 0 && id[0] == "#") {
            id = id.substring(1);
        }

        let editor = ace.edit(id);
        editor.setTheme(`ace/theme/${theme}`);
        editor.setOption("scrollPastEnd", true);

        let session = editor.getSession();
        session.setMode("ace/mode/json");
        session.setUseSoftTabs(false);

        editor.setValue(me.current.optionsJson);

        me.get("#SaveJson").tie("click", function () {
            let jsonString = editor.getValue(),
                validJson = me.parseJson(jsonString);

            if (validJson == null) {
                z.controls.alert({
                    type: "danger",
                    header: z.ll("InvalidJson"),
                    message: z.ll("InvalidJsonMessage").format(z.ll("json"))
                });
            } else {
                me.saveWidgetOptions(jsonString).done(function () {
                    me.prepare(jsonString);
                    me.renderCustomView();
                });
            }
        });

        me.get("#CancelJson").tie("click", function () {
            let existingOptions = (me.current && me.current.optionsJson) || "";
            me.prepare(existingOptions);

            me.renderCustomView();
        });
    },
    renderCustomView: function () {
        let me = this;
        me.deleteCurrentViewAndSetHeight("auto");
        me.showPrintButton(me.current.constructorObject.WidgetType !== "W_HTML");

        try {
            let widgetType = me.current.constructorObject.Widget.WidgetType.Value;
            let widget = new widgets[widgetType](me.current.constructorObject);

            // weird things happen here: force our JSON onto the object
            $.extend(widget, me.current.options);

            if (widget.initAsync) {
                widget.initAsync();
            }

            if (me.current.options.Header) {
                let header = me.get("#WidgetContainer").find(".z-widget-header");
                header.html(me.current.options.Header);
            }
        } catch (ex) {
            console.log(ex);
            me.renderEditView(true);
        }
    },
    saveWidgetOptions: function (optionsJson) {
        let me = this,
            instanceId = me.widgetInstance.Id,
            widgetId = me.widgetInstance.Widget.Id,
            widgetContainer = me.get("#WidgetContainer"),
            screenId = me.widgetInstance.ScreenId;

        widgetContainer.mask();

        return z.util.updateEntity({
            dto: {
                Id: widgetId,
                Options: optionsJson
            },
            errorHandled: true,
            entityType: "Widget",
            success: function () {

                if (localStorage.WidgetInstances) {

                    let widgetInstances = $.parseJSON(LZString.decompressFromUTF16(localStorage.WidgetInstances));

                    $.each(widgetInstances[screenId], function (widgetIndex, storedWidgetInstance) {
                        if (storedWidgetInstance.Id == instanceId) {
                            storedWidgetInstance.Options = "{}";
                            storedWidgetInstance.Widget.Options = optionsJson;
                        }
                    });

                    localStorage.WidgetInstances = LZString.compressToUTF16(JSON.stringify(widgetInstances));
                }

                z.controls.alert({
                    type: "success",
                    header: z.ll("SaveSuccessful"),
                    message: z.ll("SaveSuccessfulMessage").format(z.ll("json"))
                });

                widgetContainer.unmask();
            },
            error: function () {
                widgetContainer.unmask();

                z.controls.alert({
                    type: "danger",
                    header: z.ll("SaveFailed"),
                    message: z.ll("SaveFailedMessage").format(z.ll("json"))
                });
            }
        });
    },
    parseJson: function (json) {
        try {
            return JSON.parse(json);
        } catch (e) {
            return null;
        }
    },
    showPrintButton: function (show: boolean) {
        let me = this,
            printButton = me.get("#WidgetContainer_PrintButton");

        if (show) {
            printButton.removeClass("disabled");
        } else {
            printButton.addClass("disabled");
        }
    },
    deleteCurrentViewAndSetHeight: function (height) {
        let me = this,
            widgetContents = me.get("#WidgetContainer .z-widget-contents");

        widgetContents.empty();
        widgetContents.height(height);
    }
};
